import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, desc, moreTo, moreLabel = "查看全部" }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-50">{title}</h2>
        {desc && <p className="mt-2 text-sm text-foreground-500">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}